<template>
  <el-container class="wrap">
    <el-header class="main-header" height="80">
      <div class="branding">
        <router-link to="/">
          <!--<img src="@/assets/images/logo_scb.png" alt="SCB Payin Slip" class="logo">-->
        </router-link>
        <div class="app-title">BP Payin Slip {{ appName ? `| ${$t(appName)}` : '' }}</div>
      </div>
      <div class="menu profile-menu" v-if="isAuthenticated">
        <el-menu mode="horizontal" :router="true" :collapse-transition="false" menu-trigger="click" text-color="#000000">
          <el-submenu index="1">
            <template slot="title">ข้อมูลส่วนตัว</template>
            <el-menu-item index="/reset-password" :route="{ name: 'ResetPassword' }">เปลี่ยนรหัสผ่าน</el-menu-item>
            <el-menu-item index="/logout" :route="{ name: 'Logout' }">{{ 'Logout' | translate }}</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="profile-info" v-if="isAuthenticated">
        <i class="profile-icon">
          <font-awesome-icon :icon="faUser" />
        </i>
        {{ userName }}
        <el-tag class="user-role" v-if="isAdmin && isAdminRole" type="info">SCB ADMIN</el-tag>
        <el-tag class="user-role" v-if="isAdmin && isViewerRole" type="info">SCB VIEWER</el-tag>
        <el-tag class="user-role" v-if="isBiller && billerRole" :type="isBillerAdmin ? 'success' : 'default'">{{ billerRole }}</el-tag>
      </div>
    </el-header>
    <!--<div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">หน้าแรก</el-breadcrumb-item>
        <el-breadcrumb-item>เปลี่ยนรหัสผ่าน</el-breadcrumb-item>
      </el-breadcrumb>
    </div>-->
    <el-container class="body-wrap">
      <el-container class="content-wrap">
        <el-aside width="250px" v-if="isAuthenticated && !isNeedResetPwd && shouldShowAside">
          <el-menu
            class="scb-main-menu"
            ref="scbMainMenu"
            v-if="shouldShowMainMenu"
            @close="preventSCBSubmenuClosing"
            :router="true"
            :default-openeds="['1']"
            :default-active="currentRoutePath"
            background-color="#4c5256"
            text-color="#fff"
            active-text-color="#ffffff">
            <el-menu-item-group title="SCB Admin Menu">
              <el-menu-item index="/company" :route="{ name: 'CompanyList' }">จัดการรายชื่อบริษัท</el-menu-item>
              <el-menu-item index="/admins" :route="{ name: 'AdminAccountList' }">จัดการบัญชีผู้ใช้งาน</el-menu-item>
              <el-menu-item index="/qr-verify" @click="showQRModal">ตรวจสอบ QR</el-menu-item>
            </el-menu-item-group>
            <!--<el-menu-item-group title="Data Management">
              <el-menu-item index="/company/list" :route="{ name: 'CompanyList' }">Import From File</el-menu-item>
              <el-menu-item index="/company/list" :route="{ name: 'CompanyList' }">Export to File</el-menu-item>
            </el-menu-item-group>-->
          </el-menu>

          <el-menu
            class="company-main-menu"
            ref="companyMainMenu"
            v-if="shouldShowCompanyMenu"
            :router="true"
            :default-openeds="['1']"
            :default-active="currentCompanyRoutePath"
            background-color="#4c5256"
            text-color="#fff"
            active-text-color="#ffffff"
            @close="preventCompanySubmenuClosing">
            <el-menu-item class="company-back-btn" index="/company/list" :route="{ name: 'CompanyList' }">
              <i class="el-icon-back"></i> ย้อนกลับ
            </el-menu-item>
            <el-submenu index="1">
              <template slot="title">
                <div class="company-profile" @click.prevent="viewCompanyDetail">
                  <div class="company-logo-holder" v-if="currentCompany.logo">
                    <div class="company-logo" :style="{
                      'background-image': `url('${currentCompany.logo}')`,
                    }"></div>
                  </div>
                  <span class="company-name">{{ currentCompany.name }}</span>
                </div>
              </template>
              <el-menu-item-group title="Company Menu">
                <el-menu-item
                  v-if="isAdminRole"
                  :index="`/company/${currentCompany.id}/edit`"
                  :route="{ name: 'CompanyEdit', params: { companyId: currentCompany.id }}">
                  แก้ไขรายละเอียดบริษัท
                </el-menu-item>
                <el-menu-item :index="`/company/${currentCompany.id}/profile`" :route="{ name: 'CompanyProfileList', params: { companyId: currentCompany.id } }">
                  {{ isViewerRole ? 'ดู' : 'จัดการ'}}ข้อมูลบริษัทสำหรับรับชำระ
                </el-menu-item>
                <el-menu-item
                  :index="`/company/${currentCompany.id}/admin`"
                  :route="{ name: 'CompanyAdminList', params: { companyId: currentCompany.id } }">
                  จัดการบัญชีผู้ดูแลบริษัท
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>

          <el-menu
            class="biller-main-menu company-main-menu"
            ref="billerMainMenu"
            v-if="shouldShowBillerMenu"
            :router="true"
            :default-openeds="['1']"
            :default-active="currentBillerRoutePath"
            background-color="#4c5256"
            text-color="#fff"
            active-text-color="#ffffff"
            @close="preventBillerSubmenuClosing">
            <el-submenu index="1">
              <template slot="title">
                <div class="company-profile" @click.prevent="viewBillerCompanyDetail">
                  <div class="company-logo-holder" v-if="currentBiller.logo">
                    <div class="company-logo" :style="{
                      'background-image': `url('${currentBiller.logo}')`,
                    }"></div>
                  </div>
                  <span class="company-name">{{ currentBiller.name }}</span>
                </div>
              </template>
              <el-menu-item-group title="Company Menu">
                <el-menu-item
                  v-if="isBillerAdmin"
                  :index="`/company/edit`"
                  :route="{ name: 'BillerCompanyEdit' }">
                  แก้ไขรายละเอียดบริษัท
                </el-menu-item>
                <el-menu-item
                  :index="`/profiles`"
                  :route="{ name: 'BillerProfileList' }">
                  จัดการข้อมูลบริษัทสำหรับรับชำระ
                </el-menu-item>
                <el-menu-item
                  v-if="isBillerAdmin"
                  :index="`/users`"
                  :route="{ name: 'BillerUserList' }">
                  จัดการบัญชีผู้ดูแลบริษัท
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main class="main-content"
           v-loading.body="isContentLoading"
           :element-loading-text="$t('Loading...')">
          <transition name="fade" mode="out-in" appear>
            <router-view></router-view>
          </transition>
          <el-dialog
            class="qr-verify-dialog"
            title="ตรวจสอบ QR Code"
            :fullscreen="true"
            :visible.sync="isShowingQRModal">
            <div class="qr-uploader-holder" v-if="!isQRImporting">
              <el-upload
                class="qr-uploader"
                action=""
                v-if="qrVerificationResult === null"
                drag
                :show-file-list="false"
                :before-upload="handleBeforeQRUpload"
                :http-request="handleQRImport">
                <i class="icon el-icon-document"></i>
                <div class="el-upload__text">
                  เลือกไฟล์รูป QR Code ที่ต้องการ หรือลากมาวางที่นี่เพื่อเริ่มนำเข้าข้อมูล (นามสกุล jpg, png, gif)<br/>
                  <br/>
                  <div>
                    <span class="el-button el-button--primary">เลือกไฟล์</span>
                  </div>
                </div>
              </el-upload>
              <el-row class="qr-verification-result" v-if="qrVerificationResult !== null">
                <el-col :span="12">
                  <img class="qr-image" :src="qrFile" v-if="qrFile">
                </el-col>
                <el-col :span="12">
                  <div class="icon-holder">
                    <i class="el-icon-success icon success" v-if="qrVerificationResult.correctness === true"></i>
                    <i class="el-icon-error icon error" v-if="qrVerificationResult.correctness === false"></i>
                  </div>
                  <div class="result-text">
                    <div class="success" v-if="qrVerificationResult.correctness === true">
                      <h3 style="line-height: 1.2em;">QR Code มีรูปแบบตรงตาม{{ qrVerificationResult.format }}</h3>
                      <p class="result-code">
                        <code v-html="qrInfoFormat"></code>
                      </p>
                    </div>
                    <div class="error" v-if="qrVerificationResult.correctness === false">
                      <h3 style="line-height: 1.2em;">QR Code มีข้อผิดพลาด ({{ qrVerificationResult.format}})</h3>
                      <p v-html="qrVerificationResult.incorrectReason"></p>
                      <p class="result-code">
                        <code v-html="qrInfoFormat"></code>
                      </p>
                    </div>
                    <el-button class="reset-qr-btn" type="primary" @click="resetQR">
                      <i class="el-icon-refresh"></i>
                      เริ่มใหม่
                    </el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-dialog>
        </el-main>
      </el-container>
      <el-footer class="main-footer" height="50">
        <div class="container">
          <!--<div class="copy">
            &copy; Copyright {{ currentYear }} The Siam Commercial Bank Public Company Limited. All right reserved.
          </div>-->
        </div>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
/* eslint max-len: ["error", { "code": 200 }] */
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faUser from '@fortawesome/fontawesome-free-solid/faUser';
import jsQR from 'jsqr';
import QRChecker from '@/libs/qr';

const MainLayout = {
  name: 'main-layout',
  data() {
    return {
      isShowingQRModal: false,
      isQRImporting: false,
      qrFile: null,
      qrVerificationResult: null,
      qrInfo: '',
    };
  },
  components: {
    FontAwesomeIcon,
  },
  computed: {
    shouldShowAside() {
      if (this.$store.getters.isBiller) {
        return this.$store.getters.myAdminInfo &&
          this.$store.getters.billerInfo &&
          !this.$store.getters.isInitialLoading;
      } else if (this.$store.getters.isAdmin) {
        // return true;
        return this.$store.getters.scbAdminInfo &&
          !this.$store.getters.isAdminInitialLoading;
      }
      return false;
    },
    appName() {
      return this.$store.getters.appName;
    },
    faUser() {
      return faUser;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isBiller() {
      return this.$store.getters.isBiller;
    },
    isBillerAdmin() {
      if (this.$store.getters.myAdminInfo) {
        return this.$store.getters.myAdminInfo.role === 'ADMIN';
      }
      return false;
    },
    adminUserRole() {
      return this.$store.getters.adminUserRole;
    },
    isViewerRole() {
      return this.$store.getters.isViewerRole;
    },
    isAdminRole() {
      return this.$store.getters.isAdminRole;
    },
    billerRole() {
      if (this.$store.getters.myAdminInfo) {
        return this.$store.getters.myAdminInfo.role;
      }
      return '';
    },
    isContentLoading() {
      return this.$store.getters.isContentLoading;
    },
    currentYear() {
      const now = new Date();
      return now.getFullYear();
    },
    isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isNeedResetPwd() {
      return this.$store.getters.needResetPwd;
    },
    userName() {
      return this.$store.getters.userName;
    },
    currentRoutePath() {
      const parts = this.$store.state.route.path.split('/').filter(part => part !== '');
      if (parts.length > 0) {
        return `/${parts[0]}`;
      }
      return this.$store.state.route.path;
    },
    companyProfileRoutes() {
      return [
        'CompanyProfileCreate',
        'CompanyProfileEdit',
      ];
    },
    companyCompanyAdminRoutes() {
      return [
        'CompanyAdminCreate',
        'CompanyAdminEdit',
      ];
    },
    currentCompanyRoutePath() {
      // company profile
      // /company/{companyId}/profile
      if (this.companyProfileRoutes.indexOf(this.$store.state.route.name) !== -1) {
        const routes = this.$store.state.route.path.split('/');
        // remove the last part
        routes.pop();
        if (routes.length < 4) {
          routes.push('profile');
        }
        if (routes.length > 4) {
          while (routes.length > 4) {
            routes.pop();
          }
        }
        return routes.join('/');
      }
      if (this.companyCompanyAdminRoutes.indexOf(this.$store.state.route.name) !== -1) {
        const routes = this.$store.state.route.path.split('/');
        // remove the last part
        routes.pop();
        if (routes.length < 3) {
          routes.push('admin');
        }
        return routes.join('/');
      }
      // standard route
      return this.$store.state.route.path;
    },
    shouldShowMainMenu() {
      // return !this.shouldShowCompanyMenu;
      return this.$store.getters.isAdmin && !this.shouldShowCompanyMenu;
    },
    shouldShowCompanyMenu() {
      if (this.$store.getters.isBiller) return false;
      const isAdminInitialLoading = this.$store.getters.isAdminInitialLoading;

      const inboundPages = [
        'CompanyDetail',
        'CompanyEdit',
        'CompanyProfileList',
        'CompanyProfileDetail',
        'CompanyProfileCreate',
        'CompanyProfileEdit',
        'CompanyAdminList',
        'CompanyAdminCreate',
        'CompanyAdminEdit',
      ];
      return inboundPages.indexOf(this.$store.state.route.name) !== -1 &&
        this.currentCompany !== null && !isAdminInitialLoading;
    },
    shouldShowBillerMenu() {
      if (this.$store.getters.isAdmin) return false;
      const isInitialLoading = this.$store.getters.isInitialLoading;

      const inboundPages = [
        'BillerCompanyDetail',
        'BillerCompanyEdit',
        'BillerProfileList',
        'BillerProfileEdit',
        'BillerProfileDetail',
        'BillerSlipCreate',
        'BillerSlipEdit',
        'BillerUserList',
        'BillerUserCreate',
        'BillerUserEdit',
      ];
      return inboundPages.indexOf(this.$store.state.route.name) !== -1 &&
        this.billerInfo !== null && !isInitialLoading;
    },
    currentBillerRoutePath() {
      const profileRoutes = [
        'BillerProfileList',
        'BillerProfileDetail',
        'BillerProfileEdit',
        'BillerSlipCreate',
        'BillerSlipEdit',
      ];
      const userRoutes = [
        'BillerUserList',
        'BillerUserCreate',
        'BillerUserEdit',
      ];
      if (profileRoutes.indexOf(this.$store.state.route.name) !== -1) {
        const routes = this.$store.state.route.path.split('/');
        // remove the last part
        routes.pop();
        if (routes.length < 2) {
          routes.push('profiles');
        } else if (routes.length > 2) {
          // find how many times we have to pop excess companents
          // then pop all of them
          /* for (let p = 1; p <= (routes.length - 2) + 1; p += 1) {
            routes.pop();
          } */
          while (routes.length > 2) {
            routes.pop();
          }
        }
        return routes.join('/');
      }
      if (userRoutes.indexOf(this.$store.state.route.name) !== -1) {
        const routes = this.$store.state.route.path.split('/');
        // remove the last part
        routes.pop();
        if (routes.length < 2) {
          routes.push('users');
        }
        if (routes.length > 2) {
          // pop all of them
          for (let p = 1; p <= routes.length - 2; p += 1) {
            routes.pop();
          }
        }
        return routes.join('/');
      }
      // standard route
      return this.$store.state.route.path;
    },
    currentCompany() {
      return this.$store.getters.currentCompany;
    },
    currentBiller() {
      return this.$store.getters.billerInfo;
    },
    qrInfoFormat() {
      return this.qrInfo.replace(' ', '');
    },
  },
  methods: {
    preventSCBSubmenuClosing(index) {
      this.$refs.scbMainMenu.open(index);
    },
    preventCompanySubmenuClosing(index) {
      this.$refs.companyMainMenu.open(index);
    },
    preventBillerSubmenuClosing(index) {
      this.$refs.billerMainMenu.open(index);
    },
    viewCompanyDetail() {
      this.$router.push({
        name: 'CompanyDetail',
        params: {
          companyId: this.currentCompany.id,
        },
      });
    },
    viewBillerCompanyDetail() {
      this.$router.push({
        name: 'BillerCompanyDetail',
      });
    },
    showQRModal() {
      this.isShowingQRModal = true;
      this.isQRImporting = false;
      this.qrFile = null;
      this.qrVerificationResult = null;
    },
    handleBeforeQRUpload(file) {
      this.isQRImporting = false;
      this.qrFile = null;
      this.qrVerificationResult = null;
      let isValid = true;
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isGIF = file.type === 'image/gif';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG && !isGIF) {
        isValid = false;
        this.$message.error('กรุณาเลือกไฟล์รูป QR เป็น jpeg, png หรือ gif เท่านั้น!');
      }
      if (!isLt2M) {
        isValid = false;
        this.$message.error('รูป QR ต้องมีขนาดไม่เกิน 2MB!');
      }
      if (isValid) {
        this.qrFile = file;
      }
      return true;
    },
    handleQRImport() {
      const vm = this;
      if (vm.qrFile) {
        vm.isQRImporting = true;
        vm.qrVerificationResult = null;
        // read image content first
        const qrReader = new FileReader();
        qrReader.addEventListener('load', () => {
          const image = new Image();
          image.crossOrigin = 'Anonymous';
          image.onload = () => {
            const canvasQR = document.createElement('canvas');
            const context = canvasQR.getContext('2d');

            canvasQR.width = image.width;
            canvasQR.height = image.height;
            context.drawImage(image, 0, 0);
            const qrWidth = image.width;
            const qrHeight = image.height;

            try {
              const imagedata = context.getImageData(0, 0, image.width, image.height);
              const code = jsQR(imagedata.data, qrWidth, qrHeight);
              if (code) {
                const res = QRChecker.getVerificationResult({ result: code.data });
                vm.qrInfo = QRChecker.getHTMLInfo(res.format, { result: code.data });
                vm.qrVerificationResult = res;
              } else {
                this.$store.dispatch('ADD_ERROR_FLASH', 'ไม่สามารถอ่านข้อมูลไฟล์ QR ที่ต้องการได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
              }
            } catch (e) {
              console.error(e);
              this.$store.dispatch('ADD_ERROR_FLASH', 'ไม่สามารถอ่านข้อมูลไฟล์ QR ที่ต้องการได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
            }
          };
          image.src = qrReader.result;
          vm.qrFile = qrReader.result;
          vm.isQRImporting = false;
          vm.qrVerificationResult = null;
        }, false);
        try {
          qrReader.readAsDataURL(this.qrFile);
        } catch (e) {
          console.error(e);
          this.$store.dispatch('ADD_ERROR_FLASH', 'ไม่สามารถอ่านข้อมูลไฟล์ QR ที่ต้องการได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
          vm.isQRImporting = false;
          vm.qrFile = null;
          vm.qrVerificationResult = null;
        }
      } else {
        vm.isQRImporting = false;
        vm.qrFile = null;
        vm.qrVerificationResult = null;
      }
    },
    resetQR() {
      this.isQRImporting = false;
      this.qrFile = null;
      this.qrVerificationResult = null;
    },
  },
};
export default MainLayout;
</script>

<style lang="scss">
  @import '../assets/styles/color';
  @import '../assets/styles/transition';
  @import '../assets/styles/pages/main-layout';
  @import '../assets/styles/pages/page-content';

  .qr-uploader-holder {
    text-align: center;
    .el-upload--picture-card:hover, .el-upload:focus {
      color: $color-primary-purple;
    }
    .el-upload-dragger {
      padding: 20px;
      height: auto;
      .icon {
        font-size: 5em;
        margin-bottom: 20px;
      }
    }
    .qr-verification-result {
      text-align: center;
      width: 70%;
      margin: auto;

      .qr-image {
        max-width: 100%;
        display: block;
        margin: 0 auto;
      }
      .icon-holder {
        .icon {
          font-size: 5em;
        }
        .error {
          color: red;
        }
        .success {
          color: $color-secondary-green;
        }
      }
      .result-text {
        .error {
          color: red;
        }
        .success {
          color: $color-secondary-green;
        }
        h3 {
          font-size: 20px;
        }
      }
      .result-code {
        background: #efefef;
        padding: 10px;
        border-radius: 5px;
        text-align: left;
        color: #000;

        code {
          white-space: normal;
          word-wrap: break-word;
        }
      }
      .reset-qr-btn {
        margin-top: 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/main.vue